import { createContext, useRef, useState } from 'react';
import axios from 'axios';

const ViContext = createContext({
	selectSgg: '',
	selectEmd: '',
	sidoCode: '',
	sggCode: '',
	emdCode: '',
	pop: 1,
	prod: 1,
	consume: 1,
	mapMode: 'origin',
	weightedInfo: {
		sidoCode: '',
		sggCode: '',
		emdCode: '',
		sidoName: '전국',
		sggName: '',
		emdName: '',
		pop: 1,
		consume: 1,
		prod: 1,
	},
	selectedTab: 0,
	tabInfoArr: [
		{
			sidoCode: '',
			sggCode: '',
			emdCode: '',
			sidoName: '전국',
			sggName: '',
			emdName: '',
			pop: 1,
			consume: 1,
			prod: 1,
		},
	],
});

const ViProvider = ({ children }) => {
	const [selectSgg, setSelectSgg] = useState('region'); // 1p에서 선택하는 시군구 지역활력지수 종류 region 지역활력지수 / pop 인구활력도 / consume 소비활력도 / prod 생산활력도
	const [selectEmd, setSelectEmd] = useState('region'); // 1p에서 선택하는 시군구 지역활력지수 종류
	const [sidoCode, setSidoCode] = useState('');
	const [sggCode, setSggCode] = useState('');
	const [emdCode, setEmdCode] = useState('');
	const [pop, setPop] = useState(1); //인구활력지수 가중치
	const [prod, setProd] = useState(1); // 생산활력지수 가중치
	const [consume, setConsume] = useState(1); // 소비활력지수 가중치
	const [mapMode, setMapMode] = useState('origin'); // origin 원본, weighted 가중치

	const [weightedInfo, setWeightedInfo] = useState({
		sidoCode: '',
		sggCode: '',
		emdCode: '',
		sidoName: '전국',
		sggName: '',
		emdName: '',
		pop: 1,
		consume: 1,
		prod: 1,
	}); // 가중치 적용하기 클릭시

	const [selectedTab, setSelectedTab] = useState(0);
	const [tabInfoArr, setTabInfoArr] = useState([
		{
			sidoCode: '',
			sggCode: '',
			emdCode: '',
			sidoName: '전국',
			sggName: '',
			emdName: '',
			pop: 1,
			consume: 1,
			prod: 1,
		},
	]);

	const execFunctionLog = (funcNm, funcDesc) => {
		axios({
			method: 'POST',
			url:
				process.env.REACT_APP_CONTEXT_PATH +
				'/interactive/api/function/log.json?func_nm=' +
				funcNm +
				'&func_desc=' +
				funcDesc +
				'&item_cd=vit&item_nm=지역경제 활력도가 높은 지역은 어디일까?',
		})
			.then(() => {})
			.catch((err) => {
				console.log('functionLog error', err);
			});
	};

	return (
		<ViContext.Provider
			value={{
				selectSgg,
				selectEmd,
				sidoCode,
				sggCode,
				emdCode,
				pop,
				prod,
				consume,
				mapMode,
				weightedInfo,
				tabInfoArr,
				selectedTab,

				setSelectSgg,
				setSelectEmd,
				setSidoCode,
				setSggCode,
				setEmdCode,
				setPop,
				setProd,
				setConsume,
				setMapMode,
				setWeightedInfo,
				setTabInfoArr,
				setSelectedTab,
				// setWeightedMapRef,
				execFunctionLog
			}}
		>
			{children}
		</ViContext.Provider>
	);
};

export { ViContext, ViProvider };
